<template>
  <Modal v-if="hourModal" :isOpen="hourModal" :closeButton="false" >
    <div class="wrongTime">
      <i class="material-icons-outlined wrongTime__icon">schedule</i>
      <h3>Para continuar en la plataforma debe corregir la hora de su dispositivo.</h3>
    </div>
  </Modal>
  <div class="app-container" :class="{'logged': logged}">
    <template v-if="logged || route.query.t === 'OD'">  
      <top-nav-mobile v-if="mobileVersion && !route.query.t === 'OD' || mobileVersion && logged" @toggleMenuMobile="toggleMenuMobile()" @openHelpMenu="toggleHelpMenu()"/>
      <top-nav v-else @openUserMenu="toggleUserMenu()" @openHelpMenu="toggleHelpMenu()"/>
      <user-menu v-if="userMenuActive" @closeUserMenu="toggleUserMenu()" />
      <help-menu v-if="helpMenuActive" @closeHelpMenu="toggleHelpMenu()" @openHelpModal="helpModalActive=true" @openOnboardingModal="onboardingModalActive=true"/>
      <main-menu-mobile v-if="menuMobile" @toggleMenuMobile="toggleMenuMobile()" @openHelpModal="helpModalActive=true"/>
      <help-modal v-if="helpModalActive" @closeHelpModal="helpModalActive=false" />
      <onboarding-modal v-if="onboardingModalActive" @closeOnboardingModal="onboardingModalActive=false" />
    </template>
    <router-view v-show="!menuMobile"/>
    <Notifications />
  </div>
</template>

<script>
import TopNav from './components/TopNav.vue';
import TopNavMobile from './components/TopNavMobile.vue';
import MainMenuMobile from './components/MainMenuMobile.vue';
import UserMenu from '@/components/UserMenu.vue';
import HelpMenu from '@/components/HelpMenu.vue';
import HelpModal from '@/components/HelpModal';
import OnboardingModal from '@/components/OnboardingModal';
import Notifications from '@/components/Notifications/Main.vue';

import { computed, onMounted } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { ref, provide } from 'vue';
import { useRoute } from 'vue-router';
import moment from 'moment-timezone';
// import { useRouter } from 'vue-router';
import Modal from './components/Modal.vue';
export default {
  components: {
    TopNav,
    TopNavMobile,
    MainMenuMobile,
    UserMenu,
    HelpMenu,
    HelpModal,
    OnboardingModal,
    Notifications,
    Modal
  },
  setup() {
    // const router = useRouter();
    const store = useStore();
    const logged = computed(() => store.getters.manageUser_logged);
    const route = useRoute();
    const userMenuActive = ref(false);
    provide('userMenuActive',userMenuActive);
    const helpMenuActive = ref(false);
    const hourModal = ref(false)
    const menuMobile = ref(false);
    provide('menuMobile',menuMobile);
    const helpModalActive = ref(false);
    const onboardingModalActive = ref(false);
    provide('onboardingModalActive',onboardingModalActive);
    const mobileVersion = ref(false);
    provide('mobileVersion', mobileVersion);
    const formatDate = date => moment(date).format('DD/MM/YYYY');
    provide('formatDate', formatDate);
    const UTCDate = ref(undefined)
    provide('UTCDate', UTCDate);
    const copyToClipboard = async(text, itemName='Link')=>{
      console.log('copiando')
      try{
        await navigator.clipboard.writeText(text)
        store.dispatch('notifications_create', {text: `${itemName} copiado en portapapeles`})
      } catch{
        store.dispatch('notifications_create', {text: `Error al copiar el ${itemName}`})
      }
    }
    provide('copyToClipboard',copyToClipboard);

    const getFile = (path, container) => {
      let containerName;
      if(container == 'activity') {containerName = process.env.VUE_APP_CDN_ACTIVITY_CONTAINERNAME}
      else if(container == 'content') {containerName = process.env.VUE_APP_CDN_CONTENT_CONTAINERNAME}
      else if(container == 'user') {containerName = process.env.VUE_APP_CDN_LEARNINGUSER_CONTAINERNAME}
      else if(container == 'foroComment') {containerName = process.env.VUE_APP_CDN_FOROCOMMENT_CONTAINERNAME}

      let cdnUrl = (container == 'activity' || container == 'foroComment' 
        ?  process.env.VUE_APP_USERMEDIA_CDN
        : process.env.VUE_APP_CDN_URL);

      if(process.env.VUE_APP_STORAGE_MODE == 'ps-storage'){
        cdnUrl = (container == 'activity' || container == 'foroComment' 
        ?  process.env.VUE_APP_PSSTORAGE_USERMEDIA_URL
        : process.env.VUE_APP_PSSTORAGE_URL);
        
      }

      return cdnUrl + containerName +'/'+ path;
    } 
    provide('getFile',getFile);

    function detectMobile(){
      if(window.matchMedia("(max-width: 1000px)").matches) {
        mobileVersion.value = true;
      }

      window.addEventListener('resize', () => {
        if (window.matchMedia("(max-width: 1000px)").matches) {
          mobileVersion.value = true;
        } else {
          mobileVersion.value = false;
          menuMobile.value = false;
        }
      })
    }

    function toggleUserMenu(){
      userMenuActive.value = !userMenuActive.value;
    }

    function toggleHelpMenu(){  
      helpMenuActive.value = !helpMenuActive.value;
    }

    function toggleMenuMobile(){
      menuMobile.value = !menuMobile.value;
    }

    onMounted(async () => {
      try {
        await store.dispatch('manageUser_active');
        let { data } = await store.dispatch('stuff__date')
        let utcTime = (new Date()).getUTCHours()
        UTCDate.value = new Date(data.date)
        if (UTCDate.value.getUTCHours() - utcTime < -2 || UTCDate.value.getUTCHours() - utcTime > 2) {
          hourModal.value = true
        } 
        if(location.href.includes('changeColors') || location.href.includes('learning.fundacionforge.org')){
          document.getElementsByTagName("title")[0].innerHTML="Educative experiences"
          document.querySelector(':root').style.setProperty('--green', '#E87B1B');
        }
      } catch (e) {
        console.log(e);
      }
      detectMobile();
    });

    return{
      logged,
      toggleUserMenu,
      toggleHelpMenu,
      userMenuActive,
      helpMenuActive,
      helpModalActive,
      onboardingModalActive,
      mobileVersion,
      menuMobile,
      toggleMenuMobile,
      hourModal,
      route
    }
  },
}
</script>

<style lang="scss">
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html { 
  height: 100%; 
  font-family: 'Open Sans', sans-serif; 
}

body { 
  height: 100%; 
  background-color: #F5F5F5;
  //background-color: #7D7D7D;
;
}

.wrongTime{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  .material-icons-outlined{
    color: #F57055;
  }
}

#app { 
  height: 100%; 
}

.app-container {
  width: 100%;
}

.logged {
  .top-nav{
    width: 100%;
  }
  .main-container{
    width: 100%;
    padding: 16px;
    @media screen and (max-width: 1000px){
      padding: 8px;
    }
  }
}


@import '@/styles/main.scss';
</style>
